import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Flex, Heading, Button, Link } from '@chakra-ui/react';
import style from './style.module.scss';
import { useEffect, useState } from 'react';
import { useAuthContext } from '../../hooks/auth'

export default function Home({
  toggleActiveSidebar,
  activeSidebar,
}: {
  toggleActiveSidebar: () => void;
  activeSidebar: boolean;
}) {
  const { user } = useAuthContext();
  const [activeButton, setActiveButton] = useState("");
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname.split("/").pop() || "listForms";
    setActiveButton(currentPath);
  }, [location]);

  const sectionOptions = [
    { href: `listForms?clientId=${user?.clientId}`, label: 'Listar Formulários' },
    { href: `createForm?clientId=${user?.clientId}`, label: 'Criar novo formulário' },
    { href: `createTemplate?clientId=${user?.clientId}`, label: 'Criar form pelo payload' },
    { href: `tabulation?clientId=${user?.clientId}`, label: 'Tabulação em massa' },
    { href: `createSkills?clientId=${user?.clientId}`, label: 'Criar Skills' },
    { href: `pendency?clientId=${user?.clientId}`, label: 'Responder pendencias em massa' },
    { href: `updateForm?clientId=${user?.clientId}`, label: 'Edição de formulário' }
  ];

  const sectionOptionsTests = [
    { href: "deploy", label: 'Deploy' },
    { href: "listFormsExcluded", label: 'Listar Formulários Excluídos' }
  ];

  const handleButtonClick = (href: string) => {
    toggleActiveSidebar()
    setActiveButton(href);
  };

  return (
    <div className={`${style.sectionContainer} ${activeSidebar ? style.sidebarOpen : style.sidebarClosed}`}>

      {sectionOptions.map((button) => (
        <RouterLink to={button.href} key={button.label}>
          <Button
            onClick={() => handleButtonClick(button.href)}
            className={`${style.button} ${activeButton === button.href ? style.buttonActive : ''} ${button.href === `updateForm?clientId=${user?.clientId}` ? style.buttonDisabled : ''}`}
            disabled={button.href === `updateForm?clientId=${user?.clientId}`}
            title={button.href === `updateForm?clientId=${user?.clientId}` ? 'Selecione o formulário pela listagem' : ''}
          >
            {button.label}
          </Button>
        </RouterLink>
      ))}

      {import.meta.env.MODE !== "production" && (
        <>
          <Heading mt={4} fontSize="md">Testes</Heading>
          {sectionOptionsTests.map((button) => (
            <RouterLink to={button.href} key={button.label}>
              <Button
                onClick={() => handleButtonClick(button.href)}
                className={`${style.button} ${activeButton === button.href ? style.buttonActive : ''}`}
              >
                {button.label}
              </Button>
            </RouterLink>
          ))}
        </>
      )}
    </div>
  );
}
